export class FilterTaskModel {
  filterId?: any;
  clientId: number;
}
